import type { FC } from "react";
import { HeadsUpStateText, StateWrapper } from "./shared";
import HeadsUpNoContentStateIllustrationLight from "@/assets/images/heads-up-no-content-illustration-light.svg";
import HeadsUpNoContentStateIllustrationDark from "@/assets/images/heads-up-no-content-illustration-dark.svg";
import { useTheme } from "@/mds";
import styled from "@emotion/styled";

export const HeadsUpNoContentView: FC = () => {
  const { themeType } = useTheme();

  const illustrationSrc =
    themeType === "harvest"
      ? HeadsUpNoContentStateIllustrationLight
      : HeadsUpNoContentStateIllustrationDark;

  return (
    <StateWrapper>
      <StyledEmptyStateIllustration src={illustrationSrc} alt="No content" />
      <HeadsUpStateText as="p">
        Nothing related to this note yet. As you create more notes, Mem will bring up related
        information here.
      </HeadsUpStateText>
    </StateWrapper>
  );
};

export const StyledEmptyStateIllustration = styled.img`
  height: 164px;
  margin-top: 24px;
  margin-bottom: 12px;
`;
